var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessLeafRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 82,
    viewBox: "0 0 58 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1802 70.1941C13.0903 69.7377 14.1984 70.0698 14.7075 70.9515V70.9515C15.2166 71.8333 14.9501 72.959 14.0998 73.519L4.99182 79.517C3.75952 80.3285 2.09828 79.9353 1.36053 78.6574V78.6574C0.622771 77.3796 1.11286 75.7443 2.4318 75.0829L12.1802 70.1941Z",
    fill: "url(#paint0_linear_17232_1037)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8072 29.3119C30.6697 26.4455 27.1953 20.9563 27.1953 14.6555C27.1953 8.35539 30.6691 2.86657 35.8058 0C40.9432 2.86636 44.4176 8.35559 44.4176 14.6563C44.4176 20.9565 40.9438 26.4453 35.8072 29.3119Z",
    fill: "url(#paint1_linear_17232_1037)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.204 44.5937C35.4932 45.152 36.0794 45.4905 36.7075 45.4618C42.2307 45.2096 47.5132 42.2341 50.4827 37.0906C53.4523 31.9472 53.3879 25.8847 50.8448 20.9754C50.5556 20.4171 49.9693 20.0786 49.3412 20.1073C43.8181 20.3596 38.5356 23.335 35.566 28.4785C32.5964 33.6219 32.6609 39.6844 35.204 44.5937Z",
    fill: "url(#paint2_linear_17232_1037)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1724 60.2492C26.6142 59.96 26.2757 59.3739 26.3043 58.7458C26.5562 53.2223 29.5318 47.9393 34.6755 44.9695C39.8188 42 45.8812 42.0644 50.7904 44.6073C51.3487 44.8965 51.6871 45.4827 51.6585 46.1107C51.4066 51.6342 48.4311 56.9172 43.2873 59.887C38.144 62.8565 32.0817 62.7921 27.1724 60.2492Z",
    fill: "url(#paint3_linear_17232_1037)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0251 66.3689C39.364 66.8985 39.364 67.5753 39.0252 68.1049C36.0453 72.7626 30.8268 75.8502 24.8872 75.8502C18.9482 75.8502 13.7301 72.7633 10.7501 68.1063C10.4112 67.5768 10.4112 66.8999 10.75 66.3703C13.7299 61.7126 18.9484 58.625 24.888 58.625C30.827 58.625 36.0451 61.712 39.0251 66.3689Z",
    fill: "url(#paint4_linear_17232_1037)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17232_1037",
    x1: -6.34557,
    y1: 82.6481,
    x2: 29.4642,
    y2: 62.7035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17232_1037",
    x1: 36.2597,
    y1: 26.8942,
    x2: 36.2597,
    y2: 2.41772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17232_1037",
    x1: 46.4114,
    y1: 40.1875,
    x2: 39.7833,
    y2: 25.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17232_1037",
    x1: 42.378,
    y1: 58.0403,
    x2: 36.9633,
    y2: 45.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17232_1037",
    x1: 24.739,
    y1: 74.4903,
    x2: 24.739,
    y2: 60.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLeafRight);
export default __webpack_public_path__ + "static/media/success-leaf-right.448c92127d2a2c307dab5d3882e60e76.svg";
export { ForwardRef as ReactComponent };